import { Injectable, OnDestroy } from '@angular/core';
import { EntClipboardService, EntWindowRefService } from '@ng/ent-utilities';
import { environment } from 'environments/environment';
import { CommonService } from './common.service';
import { DataService } from 'app/shared/services/data.service';

declare let formatic: any;

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    let el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
@Injectable({
  providedIn: 'root'
})
export class AISFormotivService implements OnDestroy {
  window: any;
  guid: string;
  caseId: string;
  sessionData: any;
  incCounter = 0;
  incCounterDD = 0;

  public timer1: any;
  public timer2: any;
  public timer3: any;
  public timer4: any;
  public isEnableFormotiv = environment.config.enableFormotiv;
  formotivConfig = null;
  formotiv: any;
  constructor(
    private windowRef: EntWindowRefService,
    private clipboardService: EntClipboardService,
    private commonService: CommonService,
    private dataService: DataService
  ) {
    this.window = windowRef.getWindow();
    this.isEnableFormotiv = environment.config.enableFormotivAIS;
    this.formotiv = typeof this.window.formotiv === 'undefined' ? {} : this.window.formotiv;
  }

  setFormotiv(newSes = false, altUri?: string): void {
    if (this.isEnableFormotiv) {
      clearTimeout(this.timer1);
      this.sessionData = this.clipboardService.get('sessionData');
      this.timer1 = setTimeout(() => {
        this.reloadForDynamicForms(newSes, altUri);
      }, 300);
    }
  }

  reloadForDynamicForms(newSession: boolean, altU?: string): void {
    const userSessionData = this.dataService.getData('userSessionData');
    if (this.window.formotiv) {
      const url = this.window.location.href;
      this.formotivConfig = null;
      if (url && url.indexOf('mgeinterview.web.lfg.com') !== -1 ) {
        this.formotivConfig = this.formotiv.FormotivDefaultConfig.Instance('8409428f-ad75-4dac-8e9f-0440ecd81b00');
      } else {
        this.formotivConfig = this.formotiv.FormotivDefaultConfig.Instance('f2c02fc1-f1d8-477a-8dfd-5366e9a1436b');
      }
      this.guid = this.sessionData && this.sessionData.guid;
      this.caseId = userSessionData && userSessionData.clientCaseId;
      if (newSession) {
        const hostparam = this.window.location.hash?.split('?')[1].split('=')[1];
        this.guid = hostparam;
      }
      console.log('##########  Formotiv restart new view for forms  ##########');
      if (this.guid) {
        this.formotivConfig.state.ptv1 = this.guid;
      }
      this.formotivConfig.state.ptv2 = '';
      this.formotivConfig.state.ptv3 = 'MoneyGuard_eInterview';
      if (this.caseId) {
        this.formotivConfig.state.ptv4 = this.caseId;
      }
      if (altU) {
        this.formotivConfig.discovery.altURIHandler = {
          enabled: true,
          altFormURI: '/lfg/app/form' + altU
        };
      }
      this.formotiv.init(this.formotivConfig);
    }
  }

  reScanFormotiv(): void {
    if (this.isEnableFormotiv) {
      clearTimeout(this.timer2);
      if (this.window.formotiv) {
        console.log('##########  Formotiv re-scan new view for forms  ##########');
        this.timer2 = setTimeout(() => {
          this.formotiv.rescan(this.formotivConfig);
        }, 150);
      }
    }
  }

  reScaneFormotiv(): void {
    if (this.isEnableFormotiv) {
      clearTimeout(this.timer2);
      if (this.window.formotiv) {
        this.formotiv = typeof this.window.formotiv === 'undefined' ? {} : this.window.formotiv;
        console.log('##########  Formotiv re-scan new view for forms  ##########');
        this.timer2 = setTimeout(() => {
          this.formotiv.rescan(this.formotivConfig);
        }, 500);
      }
    }
  }

  formotivGetSignal(): void {
    if (this.window.formotiv && this.isEnableFormotiv) {
      this.formotiv = typeof this.window.formotiv === 'undefined' ? {} : this.window.formotiv;
      this.formotiv.client.getSignals();
    }
  }

  triggerPageSubmit(domObj: any): void {
    if (this.isEnableFormotiv && domObj && this.window.formotiv) {
      console.log('##########  formotive page submit triggered  ##########');
      this.formotiv.submit(this.formotivConfig);
    }
  }

  triggerMultipageComplete(): void {
    if (this.window.formotiv && this.isEnableFormotiv) {
      console.log('##########  formotive multipageforms complete triggered  ##########');
      this.formotiv.submitFinal(this.formotivConfig);
    }
  }

  pageSubmit(inputThis, tab): void {
    if (this.window.formatic && this.isEnableFormotiv) {
      this.checkFormotiv(inputThis, tab);
    }
  }

  checkFormotiv(inputThis, tab) {
    const self = inputThis;
    let pageNum;
    if (self.enableStep === 1) {
      pageNum = 1;
    } else if (self.enableStep === 2) {
      pageNum = 1;
    } else if (self.enableStep === 3) {
      pageNum = 2;
    } else if (self.enableStep === 4) {
      pageNum = 3;
    } else if (self.enableStep === 5) {
      pageNum = 4;
    } else if (self.enableStep === 6) {
      pageNum = 5;
    } else if (self.enableStep === 7) {
      pageNum = 6;
    }

    let formName = '';
    if (tab === 'ltc') {
      formName = 'ltcPage' + pageNum;
    } else if (tab === 'appPart2') {
      formName = 'appPart2Page' + pageNum;
    } else if (tab === 'appPart3') {
      formName = 'appPart3Page' + pageNum;
    }

    const domObj = self.document.getElementById(formName);
    if (formName === 'appPart2Page1' && !this.dataService.getData('isAUMG')) {
      this.triggerPageSubmit(self.document.getElementById('physianGridForm'));
    }

    const contractState = this.dataService.getData('contractState');
    this.isFormNull(contractState, formName);
    this.triggerPageSubmit(domObj);
  }

  isFormNull(contractState, formName): void {
    if ((contractState !== 'CA' && formName === 'appPart2Page4') || (contractState === 'CA' && formName === 'appPart2Page3')) {
      const form = self.document.getElementById('medicationGridForm');
      if (form != null && form !== undefined) {
        this.triggerPageSubmit(form);
      }
    }
  }

  //triggerChangeCustom(id: string, type: string, nameOfField: string, formName?: string, data?: any): void {
  triggerChangeCustom(type: string, id: string, nameOfField: string, formName?: string, data?: any): void {
    if (this.window.formotiv && this.isEnableFormotiv) {
      let friendlyName;
      if (data?.fieldId) {
        friendlyName = data.fieldId;
      } else {
        friendlyName = null;
      }
      this.formotiv.inputActivity(
        this.formotivConfig,
        type === 'dropdown' && friendlyName ? friendlyName : nameOfField,
        type,
        'null',
        formName
      );
    }
  }

  formotivIdCreation(data: any, type?: any) {
    let formotivDDId = '';
    if (data?.questId && data.isReflexive) {
      formotivDDId =
        data.questId.toString().replace(/[\s\(\)#&\-\/\\!@$*~]/gi, '_') +
        '_' +
        data.disclosureId.toString().replace(/[\s\(\)#&\-\/\\!@$*~]/gi, '_');
    } else if (data?.questId) {
      formotivDDId = data.questId.toString().replace(/[\s\(\)#&\-\/\\!@$*~]/gi, '_');
    } else {
      formotivDDId = 'formotiv_element_' + this.incCounterDD;
    }
    this.incCounterDD++;
    return formotivDDId;
  }

  formotivTextLabel(data: any): string {
    let txtLabel = '';
    if (data && data.questId) {
      txtLabel = data.questId;
    } else if (data) {
      txtLabel = data.toString().replace(/[\s\(\)#&\-\/\\!@$*~.\?]/gi, '_');
    }
    return txtLabel;
  }

  ngOnDestroy(): void {
    clearTimeout(this.timer1);
    clearTimeout(this.timer2);
  }
}
